// single
export const directions = ['top', 'right', 'bottom', 'left', 'topRight', 'bottomRight', 'bottomLeft', 'topLeft'];
export const DEFAULT_SIZE = {
  width: 'auto',
  height: 'auto'
};